import { Logging } from '#common/logging';
import { createTaskIntervalScheduler } from './task-interval-scheduler';
export class PeriodicTaskBase {
    defaultIntervalMs;
    log;
    scheduler;
    constructor(loggerName, defaultIntervalMs) {
        this.defaultIntervalMs = defaultIntervalMs;
        this.log = Logging.getLogger(loggerName);
        this.scheduler = createTaskIntervalScheduler(() => this.execute(), (err) => this.onError(err));
    }
    /** Override to customize error handling */
    onError(err) {
        this.log.error(err);
    }
    start(intervalMs) {
        this.scheduler.start(intervalMs ?? this.defaultIntervalMs);
    }
    async stop() {
        await this.scheduler.stop();
    }
}
